import ToggleBlock from '../../../Cards/ToggleBlock';
import StandardizedDataTable from '../../../PrimeAids/StandardizedDataTable';

const LabelAndReportBlock = ({ label, data, columns }) => {
    const isDisabled = data.length === 0;
    const subLabel = `${data.length} ${data.length === 1 ? 'item' : 'items'}`;

    return (
        <div className="my-6">
            <ToggleBlock label={label} subLabel={subLabel} isDisabled={isDisabled}>
                <div className="p-3">
                    <StandardizedDataTable data={data} columns={columns} />
                </div>
            </ToggleBlock>
        </div>
    );
};
export default LabelAndReportBlock;
